import React from 'react'

import { apiDelete } from 'utils/api'

export class Photo extends React.PureComponent {
  state = {
    deleting: false,
    deleted: false
  }

  style () {
    if (!this.props.photo.thumb_url) return null
    return {
      backgroundImage: `url(${this.props.photo.thumb_url})`
    }
  }

  delete (e) {
    if (!this.props.canDelete) return

    e.stopPropagation()
    if (window.confirm('Přejete si opravdu fotku smazat?')) {
      this.beforeDelete()
      apiDelete(this.props.photo.delete_url)
        .then(() => this.onDelete())
        .catch(() => this.onDeleteFailure())
    }
  }

  beforeDelete () {
    this.setState({
      ...this.state,
      deleting: true
    })
  }

  onDelete () {
    this.setState({
      ...this.state,
      deleted: true,
      deleting: false,
    })
  }

  onDeleteFailure () {
    this.setState({
      ...this.state,
      deleting: false
    })
  }

  uploading () {
    return !!this.props.photo.file
  }

  className () {
    let names = ['ui', 'photo']
    if (this.state.deleted) names.push('deleted')
    if (this.state.deleting) names.push('deleting')
    if (this.uploading()) names.push('uploading')
    return names.join(' ')
  }

  render () {
    return (
      <div className={this.className()} onClick={this.props.onClick}>
        <div className='ui photo-inner' style={this.style()}>
          {this.props.canDelete && (
            <span className='ui photo-delete' onClick={(e) => this.delete(e)}>
              <i className='trash outline icon' />
            </span>
          )}

          <span className='ui photo-uploading'>
            <i className='upload icon' />
          </span>

          <span className='ui photo-zoom-hint'>
            <i className='fa fa-search-plus' />
          </span>
        </div>
      </div>
    )
  }
}

export default Photo



// WEBPACK FOOTER //
// ./app/javascript/components/ItemPhotos/Photo.js